<template>
  <div>
    <v-autocomplete ref="auditor" v-model="selected" :items="items" :item-text="nombreCompleto" item-value="uuid"
      :rules="rules" :required="required" :disabled="disabled" :dense="dense" :label="title" :multiple="multiple"
      :hide-details="show_hint" :clearable="clearable" outlined dense return-object @change="emitChange()" @click:clear="clear()"
      :key="component">
    </v-autocomplete>
  </div>
</template>

<script>
/**
 * @project: certiapp-nuxt
 * @file:    SelectAuditoresMultiple.vue
 * @desc:    ...
 * -------------------------------------------
 * Created Date: 29th October 2021
 * Last Modified: Tue Dec 20 2022
 **/

import moment from 'moment'
import format from '~/util/formatHelper'

export default {
  name: 'SelectAuditores',
  props: {
    value: {
      type: [Array, Object],
      default: () => ([]),
    },
    title: { type: String, default: 'Auditor' },
    desde: { type: String, default: '' },
    subalcance: { type: String, default: '' },
    cliente: { type: String, default: '' },
    dense: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true },
    select_all: { type: Boolean, default: false },
    compatibles: { type: Boolean, default: false },
    auditorOrigen: { type: String, default: '' },
    clearable: { type: Boolean, default: true },
    restrain: Function,
  },
  data(ctx) {
    return {
      component: 0,
      selected: Array.isArray(ctx.value) ? ctx.value : [],
      auditores: [],
    }
  },
  computed: {
    show_hint() {
      return this.cliente && this.subalcance ? true : false
    },
    rules() {
      if (this.required) {
        return this.multiple
          ? [(v) => (!!v && !!v.length) || 'Obligatorio']
          : [(v) => !!v || 'Obligatorio']
      } else return []
    },
    items() {
      if (this.auditores.length === 0) return []
      return this.auditores.filter((item) => {
        if (!item.activo) return false
        if (this.restrain) {
          if (!this.restrain(item)) return false
        }

        if (this.desde !== '') {
          const incompatible = this.isIncompatible(item).incompatible
          const no_afinidad = this.isIncompatible(item).no_afinidad
          return this.compatibles ? !incompatible && !no_afinidad : true
        }

        return true
      })
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.selected = this.normalizeSelected(val)
      },
    },
    items(newItems) {
      if (!Array.isArray(newItems) || !newItems.length) return
      const selected = this.normalizeSelected(this.selected)
      if (!selected.length) return

      const selectedUuids = new Set(selected.map((aud) => aud.uuid))
      this.selected = newItems.filter((aud) => selectedUuids.has(aud.uuid))
    },
    select_all(val) {
      if (val) {
        this.selected = this.items
        this.emitChange()
      }
    },
    subalcance(newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.init()
    },
    cliente(newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.init()
    },
    desde(newVal, oldVal) {
      if (newVal && newVal !== oldVal) this.init()
    },
    auditores(newVal) {
      //console.log('👁 auditores cargados:', newVal.length)
      //console.log('👁 value actual:', this.value)
    },
  },
  methods: {
    normalizeSelected(val) {
      if (!Array.isArray(val)) return []
      return val.filter((item) => item && item.uuid)
    },
    nombreCompleto(item) {
      return format.fullName(item, { is: 'auditor' })

      if (item) {
        let nombre = item.nombre
        if (item.apellido1) nombre += ' ' + item.apellido1
        if (item.apellido2) nombre += ' ' + item.apellido2
        if (item.primer_apellido) nombre += ' ' + item.primer_apellido
        if (item.segundo_apellido) nombre += ' ' + item.segundo_apellido
        if (item.apellidos) nombre += ' ' + item.apellidos
        return nombre
      } else return ''
    },
    clear() {
      this.$emit('clear')
    },
    emitChange() {
      this.$emit('input', this.selected)
      this.$emit('change', this.selected)

      const selectedCount = Array.isArray(this.selected) ? this.selected.length : 0
      const itemsCount = Array.isArray(this.items) ? this.items.length : 0

      if (selectedCount !== itemsCount) this.clear()
      else this.$emit('all')
    },
    isVigenciaActiva(afinidad) {
      const today = moment()
      const desde = moment(afinidad.desde)
      const hasta = moment(afinidad.hasta)
      return today.isSameOrAfter(desde) && today.isSameOrBefore(hasta)
    },
    filtraThisAuditoresItems(array, tipoCompetenciaParaBuscar) {
      if (!tipoCompetenciaParaBuscar) {
        this.auditores = []
        return
      }
      this.auditores = array.filter(auditor =>
        auditor.afinidades?.some(af => {
          const isSubalcance = af.subalcance?.uuid === this.subalcance || af.subalcance === this.subalcance
          const isCompetencia = Array.isArray(af.nivelCompetencia)
                                ? af.nivelCompetencia.some(c => String(c).toUpperCase().includes(tipoCompetenciaParaBuscar))
                                : String(af.nivelCompetencia || '').toUpperCase().includes(tipoCompetenciaParaBuscar)
          const isValidDate = this.isVigenciaActiva(af)

          /*console.log({
            auditor: auditor.uuid,
            subalcance: af.subalcance?.uuid,
            isSubalcance,
            nivel: af.nivelCompetencia,
            isCompetencia,
            isValidDate
          })*/
          return isSubalcance && isCompetencia && isValidDate
        })
      )
    },
    async init() {
      let pagination = { page: 1, perPage: 1000 }
      const res = await this.$store.dispatch('auditores/list', pagination)
      //console.log('📥 auditores recibidos:', Array.isArray(res) ? res.length : res)
      if (res && this.auditorOrigen) {
        let tipoCompetencia = ''
        switch (this.auditorOrigen) {
          case 'ORIGEN_AUDITORIA':
            tipoCompetencia = 'COMPETENCIA_AUDITOR'
            break
          case 'ORIGEN_EXPEDIENTE':
            tipoCompetencia = 'COMPETENCIA_AUDITOR'
            break
          case 'ORIGEN_PROPOSICION_AUDITOR1':
            tipoCompetencia = 'COMPETENCIA_REVISOR'
            break
          case 'ORIGEN_PROPOSICION_AUDITOR2':
            tipoCompetencia = 'COMPETENCIA_REVISOR'
            break
          case 'ORIGEN_REVISION_CHECKLIST':
            tipoCompetencia = 'COMPETENCIA_REVISOR'
            break
          case 'ORIGEN_DICTAMEN':
            tipoCompetencia = 'COMPETENCIA_CERTIFICADOR'
            break
          case 'ORIGEN_PLANIFICADOR_AUDITORES':
            tipoCompetencia = 'COMPETENCIA_AUDITOR'
            break
          default:
            tipoCompetencia = ''
            break
        }
        this.filtraThisAuditoresItems(res, tipoCompetencia)
        //console.log('auditores filtrados:', this.auditores)
      }else{
        //console.warn('role', this.auditorOrigen)
        this.auditores = res.filter(auditor => auditor.roles && auditor.roles.some(rol => rol === this.auditorOrigen));
      }
      //console.warn(this.selected, this.items)
      const selectedCount = Array.isArray(this.selected) ? this.selected.length : 0
      const itemsCount = Array.isArray(this.items) ? this.items.length : 0
      selectedCount !== itemsCount ? this.clear() : this.$emit('all')
    },
    async isIncompatible(item) {
      const obj = {
        cliente: false,
        subalcance: false,
        fecha: false,
        no_afinidad_subalcance: true,
        no_afinidad_fecha: true,
      }

      item.afinidades = await this.$store.dispatch('auditores/getCompetencias', item.uuid)
      item.incompatibilidades = await this.$store.dispatch(
        'auditores/getIncompatibilidades',
        item.uuid
      )

      //console.log('afinidades', item.afinidades)
      //console.log('incompatibilidades', item.incompatibilidades)

      for (let i = 0; i < item.afinidades.length; i++) {
        const afinidad = item.afinidades[i]

        if (afinidad.subalcance == this.subalcance) obj.no_afinidad_subalcance = false

        const desde = moment(afinidad.desde).format('YYYY-MM-DD')
        const hasta = moment(afinidad.hasta).format('YYYY-MM-DD')

        const isSameOrBefore = moment(this.desde).isSameOrBefore(hasta)
        const isSameOrAfter = moment(this.desde).isSameOrAfter(desde)

        if (isSameOrBefore && isSameOrAfter) obj.no_afinidad_fecha = false
      }

      for (let i = 0; i < item.incompatibilidades.length; i++) {
        const incompatibilidad = item.incompatibilidades[i]

        if (incompatibilidad.cliente === this.cliente) obj.cliente = true
        if (incompatibilidad.subalcance === this.subalcance) obj.subalcance = true

        const desde = moment(incompatibilidad.desde).format('YYYY-MM-DD')
        const hasta = moment(incompatibilidad.hasta).format('YYYY-MM-DD')

        const isSameOrBefore = moment(this.desde).isSameOrBefore(hasta)
        const isSameOrAfter = moment(this.desde).isSameOrAfter(desde)

        if (isSameOrBefore && isSameOrAfter) obj.fecha = true
      }

      obj.incompatible = obj.cliente && obj.subalcance && obj.fecha
      obj.no_afinidad = obj.no_afinidad_subalcance || obj.no_afinidad_fecha

      return obj
    },
  },
  created() {
    //console.log('🟢 created() - value inicial:', this.value)
    //console.log('🟢 subalcance:', this.subalcance, 'cliente:', this.cliente)
    //console.log('auditorOrigen recibido:', this.auditorOrigen)
    //console.log('subalcance recibido:', this.subalcance)
    this.init()
  },
}
</script>
